<template>
	<div class="d-inline-block text-right">
		<div class="fs-12 text-nowrap text-muted text-line-through" v-if="showBase" v-html="value.base"></div>
		<div>
			<span class="text-nowrap" v-html="value.price"></span>
			<template v-if="hasRanges()">
				<PriceRange
					:ranges="product.quantityRanges"
					:prices="product.prices"
					:type="type"
					:measureTitle="product.measure"
				/>
			</template>
		</div>
		<div class="badge badge-danger" v-if="showPercent" v-html="value.percent + '%'"></div>
	</div>
</template>
<script>
import FieldMixin from './FieldMixin.js';
import PriceRange from '../PriceRange.vue';
import { checkQuantityRange } from '../utils';

export default {

	mixins: [FieldMixin],

	components: { PriceRange },

	props: {
		type: String,
		quantity: [ Number, String ]
	},

	computed: {

		range()
		{
			const quantity = !this.quantity ? this.product.ratio : this.quantity;
			return Object.values(this.product.quantityRanges).find(range => checkQuantityRange(range, quantity));
		},

		value()
		{
			return this.range ? this.product.prices[this.range.hash][this.type] : '';
		},

		showBase()
		{
			return this.$root.params.arParams['SHOW_OLD_PRICE'] && this.value.percent > 0
		},

		showPercent()
		{
			return this.$root.params.arParams['SHOW_DISCOUNT_PERCENT'] && this.value.percent > 0
		},
	},

	methods: {

		hasRanges()
		{
			return Object.keys(this.product.quantityRanges).length > 1;
		},

	}

}
</script>